import React, { Component } from 'react';
import GoalListing from '../../components/GoalListing/GoalListing';
import AddButton from '../../components/CustomButtons/AddButton';
import { connect } from 'react-redux';

// import './Goals.css';
import { trackPromise } from 'react-promise-tracker';

import './Goals.css';
require('dotenv').config();

class GoalListingPage extends Component {
  state = {
    goals: [],
  };

  componentDidMount() {
    const { authedUser } = this.props;
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    };
    trackPromise(
      fetch(
        `https://n4utl89pg0.execute-api.us-east-2.amazonaws.com/Prod?username=${authedUser}`,
        requestOptions
      )
        .then(response => response.text())
        .then(result => {
          JSON.parse(result).items.forEach(item => {
            const { answers, response_id } = item;
            const title = answers[0].text;
            this.setState(prevState => ({
              goals: prevState.goals.concat([[title, response_id]]),
            }));
          });
        })
        .catch(error => {
          console.log(error);
        })
    );
  }
  addClickHandler = () => {
    this.props.history.push('/newgoal');
  };
  manageClickHandler = response_id => {
    this.props.history.push(`/goaldashboard/${response_id}`);
  };
  render() {
    const { goals } = this.state;
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'stretch',
          alignItems: 'flex-end',
          textAlign: 'center',
          backgroundSize: 'cover',
          minWidth: '100%',
          minHeight: '100%',
          width: '100vh',
          height: '100vh',
          margin: '0',
        }}
        className='goals-div'
      >
        {goals.map((goal, index) => (
          <GoalListing
            key={index}
            title={goal[0]}
            onClick={() => this.manageClickHandler(goal[1])}
          />
        ))}
        <AddButton
          onClick={this.addClickHandler}
          style={{
            alignSelf: 'flex-end',
            marginLeft: '100vh',
            marginBottom: '15vh',
          }}
        />
      </div>
    );
  }
}

function mapStateToProps({ authedUser }) {
  return {
    authedUser,
  };
}

export default connect(mapStateToProps)(GoalListingPage);
